module.exports = __webpack_public_path__ + "img/47-lzzyjsxy.27665394.png";